import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import {
    BLOCKS,
    INLINES,
    MARKS,
    Document,
    Text,
} from '@contentful/rich-text-types';

interface Props {
    document: Document;
    target?: '_self' | '_blank' | '_parent' | '_top' | string;
}

const ContentfulRichText = ({ document, target="_blank" }: Props) => {
    // debugger;
    return (
        <div className="prose">
            {documentToReactComponents(document, {
                renderMark: {
                    [MARKS.BOLD]: (text: React.ReactNode) => <strong>{text}</strong>,
                    [MARKS.ITALIC]: (text: React.ReactNode) => <em>{text}</em>,
                    [MARKS.CODE]: (text: React.ReactNode) => (
                        <code className="bg-gray-100 px-1 rounded">{text}</code>
                    ),
                },
                renderNode: {
                    [BLOCKS.HEADING_1]: (node, children) => (
                        <h1 className="text-3xl font-bold my-4">{children}</h1>
                    ),
                    [BLOCKS.HEADING_2]: (node, children) => (
                        <h2 className="text-2xl font-semibold my-3">{children}</h2>
                    ),
                    [BLOCKS.PARAGRAPH]: (node, children) => <p className="mb-4">{children}</p>,
                    [BLOCKS.QUOTE]: (node, children) => (
                        <blockquote className="border-l-4 pl-4 italic text-gray-600">{children}</blockquote>
                    ),
                    [INLINES.HYPERLINK]: (node, children) => (
                        <a
                            href={node.data.uri}
                            className="text-blue-600 underline hover:text-blue-800"
                            target={target}
                            rel="noopener noreferrer"
                        >
                            {children}
                        </a>
                    ),
                },
            })}
        </div>
    );
}

export default ContentfulRichText;
